import styled from "styled-components"
import { Input } from 'linkdrop-ui'

export const InputStyled = styled(Input)`

`